import { Pipe, PipeTransform } from '@angular/core';

import { ProgrammingUtilsService, DAYS_OF_THE_WEEK } from './../services/utils.service';

@Pipe({
  name: 'scheduleTitle'
})
export class ScheduleTitlePipe implements PipeTransform {

  constructor(
    private utils: ProgrammingUtilsService
  ) { }

  transform(schedule: any, args?: any): any {
    let display = '';

    if (schedule && schedule.next_occurence) {
      // "[Starting] On MM/DD/YYYY, [Every Week On Monday,...,] at 7:00am [+/- ## minutes]"
      // "On MM/DD/YYYY, at 7:00am"
      // "Starting MM/DD/YYYY, Every Week on Monday,... at 7:00am"
      // "[Starting] On MM/DD/YYYY, Every Day at 7:00am +/- 15 minutes"
      // "[Starting] On MM/DD/YYYY, Every 3 Days at 7:00am"

      // if (schedule.repeat && schedule.repeat.frequency) {
      //   display += 'Starting ';
      // } else {
      //   display += 'On ';
      // }

      let next = schedule.next_occurence;
      display += this.utils.toDateDisplay(next.year, next.month, next.day);

      display += ' at '
      display += this.utils.toTimeDisplay(next.year, next.month, next.day, ((next.hour * 60) + next.min));

      if (schedule.randomizeBy) {
        display += ' +/- ';
        display += schedule.randomizeBy;
        display += ' minutes';
      }
    }

    return display;
  }

  private composeDaysOfTheWeekDisplay(days: number): string {
    let display = '';

    for (var i = 0; i < 7; i++) {
      let val = Math.pow(2, i);
      if ((days & val) === val) {
        display += (DAYS_OF_THE_WEEK[i].toUpperCase().charAt(0));
      }
    }

    return display;
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/pipes/schedule-title.pipe.ts